// value of T[type] musst be number to allow the search
// This search only works for sorted arrays
export const binarySearchObject = <T>(arr: T[], val: number, type: keyof T): T | undefined => {
  let start = 0
  if (!arr) return undefined
  let end = arr.length - 1

  while (start <= end) {
    const mid = Math.floor((start + end) / 2)

    if ((arr[mid][type] as unknown as number) === val) {
      return arr[mid]
    }

    if (val < (arr[mid][type] as unknown as number)) {
      end = mid - 1
    } else {
      start = mid + 1
    }
  }

  return undefined
}
